import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex items-center mb-4 space-x-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "arrow_back", -1)
const _hoisted_4 = { class: "mb-0.5" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex mt-8 mb-12" }
const _hoisted_7 = { class: "flex flex-col items-center w-1/3 mr-4 card shadow-elevation" }
const _hoisted_8 = { class: "flex space-x-0.5 text-2xl items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-3xl material-icons icon-light" }, "people", -1)
const _hoisted_10 = { class: "text-sm text-muted" }
const _hoisted_11 = { class: "flex flex-col items-center w-1/3 mr-4 card shadow-elevation" }
const _hoisted_12 = { class: "flex space-x-0.5 text-2xl items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-3xl material-icons-two-tone two-tone-success" }, "assignment_turned_in", -1)
const _hoisted_14 = { class: "text-sm text-muted" }
const _hoisted_15 = { class: "flex flex-col items-center w-1/3 card shadow-elevation" }
const _hoisted_16 = { class: "flex space-x-0.5 text-2xl items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "%", -1)
const _hoisted_18 = { class: "text-sm text-center text-muted" }
const _hoisted_19 = { class: "hidden md:ml-auto banner banner-light" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined icon-light" }, " assignment_returned ", -1)
const _hoisted_21 = { class: "text-lg inline-icon text-success material-icons-outlined" }
const _hoisted_22 = { style: {"margin-left":"-1px"} }
const _hoisted_23 = {
  key: 0,
  class: "flex my-4 transition-all duration-200 banner banner-danger"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "ml-px text-yellow-900 material-icons-outlined" }, " pending_actions ", -1)
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "w-full h-96" }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 2,
  class: "flex flex-col space-y-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_ExerciseWithStats = _resolveComponent("ExerciseWithStats")!
  const _component_MinimalExercisePreviewSkeleton = _resolveComponent("MinimalExercisePreviewSkeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "",
        to: { name: 'ExamResults' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Btn, {
            outline: true,
            variant: 'icon',
            tooltip: _ctx.$t('event_stats.back_to_results')
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["tooltip"])
        ]),
        _: 1
      }),
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("event_stats.event_stats")) + " " + _toDisplayString(_ctx.mainStore.getEventById(_ctx.eventId).name), 1)
    ]),
    _createVNode(_component_Tabs, {
      class: "mb-8",
      options: _ctx.tabsAsSelectableOptions,
      modelValue: _ctx.currentTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentTab) = $event))
    }, null, 8, ["options", "modelValue"]),
    _createElementVNode("div", null, [
      (!_ctx.loading)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.participantCount), 1),
                  _hoisted_9
                ]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("event_monitor.stats_participants")), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.turnedInCount), 1),
                  _hoisted_13
                ]),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("event_monitor.stats_turned_in")), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.averageProgress), 1),
                  _hoisted_17
                ]),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("event_monitor.stats_average_progress")), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("event_monitor.un_turn_in_instructions")) + " ", 1),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.participationStateIcons[_ctx.EventParticipationState.TURNED_IN][0]), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("event_monitor.in_column_state")), 1)
                ])
              ])
            ]),
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("event_stats.score_distribution")), 1),
            (!_ctx.areAllParticipationsFullyAssessed(_ctx.mainStore.eventParticipations))
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("event_stats.incomplete_scores")) + ".", 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_Bar, {
                "chart-data": _ctx.scoreFrequencyChartData,
                "chart-options": _ctx.scoreChartOptions,
                height: _ctx.mediaQueryMdMatches ? 100 : 300
              }, null, 8, ["chart-data", "chart-options", "height"])
            ])
          ], 512)), [
            [_vShow, _ctx.currentTab === _ctx.ExamStatsTabs.OVERALL]
          ])
        : _createCommentVNode("", true),
      (!_ctx.localLoading)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("event_stats.per_exercise_stats")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exercises, (exercise, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'e-stats-' + exercise?.id + '-' + index,
                class: "my-8"
              }, [
                exercise
                  ? (_openBlock(), _createBlock(_component_ExerciseWithStats, {
                      key: 0,
                      exercise: exercise,
                      slots: _ctx.getSlotsContaining(exercise)
                    }, null, 8, ["exercise", "slots"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 512)), [
            [_vShow, _ctx.currentTab === _ctx.ExamStatsTabs.EXERCISES]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createVNode(_component_MinimalExercisePreviewSkeleton),
            _createVNode(_component_MinimalExercisePreviewSkeleton),
            _createVNode(_component_MinimalExercisePreviewSkeleton),
            _createVNode(_component_MinimalExercisePreviewSkeleton)
          ], 512)), [
            [_vShow, _ctx.currentTab === _ctx.ExamStatsTabs.EXERCISES]
          ])
    ])
  ]))
}